module.exports = __webpack_public_path__ + "static/media/Cattleya.212a43fb.png";